/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Artist } from '../models/Artist';
import type { ArtistChange } from '../models/ArtistChange';
import { request as __request } from '../core/request';

export class ArtistService {

    /**
     * Get Artist
     * @param artistId
     * @result Artist Successful Response
     * @throws ApiError
     */
    public static async getArtist({
        artistId,
    }: {
        artistId: string,
    }
): Promise<Artist> {
    const result = await __request({
        method: 'GET',
        path: `/artist/get_artist`,
        query: {
            'artist_id': artistId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Artist By Slug
 * @param slug
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async getArtistBySlug({
    slug,
}: {
    slug: string,
}
): Promise<Artist> {
    const result = await __request({
        method: 'GET',
        path: `/artist/get_artist_by_slug`,
        query: {
            'slug': slug,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Edit Full Artist
 * @param requestBody
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async editFullArtist({
    requestBody,
}: {
    requestBody: Artist,
}
): Promise<Artist> {
    const result = await __request({
        method: 'POST',
        path: `/artist/edit_full_artist`,
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Create Artist
 * @param requestBody
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async createArtist({
    requestBody,
}: {
    requestBody: Artist,
}
): Promise<Artist> {
    const result = await __request({
        method: 'POST',
        path: `/artist/create_artist`,
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Last Artist Version
 * @param artistId
 * @result ArtistChange Successful Response
 * @throws ApiError
 */
public static async getLastArtistVersion({
    artistId,
}: {
    artistId: string,
}
): Promise<ArtistChange> {
    const result = await __request({
        method: 'GET',
        path: `/artist/get_last_artist_version`,
        query: {
            'artist_id': artistId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Delete Artist
 * @param artistId
 * @result any Successful Response
 * @throws ApiError
 */
public static async deleteArtist({
    artistId,
}: {
    artistId: string,
}
): Promise<any> {
    const result = await __request({
        method: 'POST',
        path: `/artist/delete_artist`,
        query: {
            'artist_id': artistId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get My Artists
 * @param limit
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async getMyArtists({
    limit,
}: {
    limit?: number,
}
): Promise<Array<Artist>> {
    const result = await __request({
        method: 'GET',
        path: `/artist/get_my_artists`,
        query: {
            'limit': limit,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Similar Artists
 * @param artistId
 * @param limit
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async getSimilarArtists({
    artistId,
    limit = 10,
}: {
    artistId: string,
    limit?: number,
}
): Promise<Array<Artist>> {
    const result = await __request({
        method: 'GET',
        path: `/artist/get_similar_artists`,
        query: {
            'artist_id': artistId,
            'limit': limit,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Generate Similar Artists
 * @param artistId
 * @param limit
 * @param saveArtist
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async generateSimilarArtists({
    artistId,
    limit = 10,
    saveArtist = true,
}: {
    artistId: string,
    limit?: number,
    saveArtist?: boolean,
}
): Promise<Array<Artist>> {
    const result = await __request({
        method: 'PATCH',
        path: `/artist/generate_similar_artists`,
        query: {
            'artist_id': artistId,
            'limit': limit,
            'save_artist': saveArtist,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

}